import React from 'react';
import LinkedinFull from '../assets/images/share/linkedin_full.png';
import LinkedinIcon from './icons/LinkedinIcon';
import FullImageShare from './ui/FullImageShare';

export default function LinkedinFeedButton({ disabled, cert, onSendEvent, fullIcon }) {
    return (
        <>
            {disabled && <LinkedinIcon fill={'#F6F6F6'} icon={'#1E1E1E'} />}
            {!disabled && (
                <a
                    href={'https://www.linkedin.com/oauth/v2/authorization?'
                        .concat('&response_type=code')
                        .concat('&client_id=')
                        .concat(import.meta.env.VITE_LINKEDIN_CLIENT_ID)
                        .concat('&redirect_uri=')
                        .concat(encodeURIComponent(new URL(import.meta.env.VITE_VIEWER_API_ROOT).origin.concat('/li')))
                        .concat('&state='.concat(cert.id))
                        .concat('&scope=w_member_social openid profile')}
                    target={'_self'}
                    onClick={() => onSendEvent('linkedin-feed')}
                    style={{ cursor: 'pointer' }}
                >
                    {fullIcon && <FullImageShare img={LinkedinFull} />}
                    {!fullIcon && <LinkedinIcon fill={'#2867B2'} />}
                </a>
            )}
        </>
    );
}
